import request from "@/global/request/request";
import API from "@/global/request/api";

const dataService = {
  dataBalance() {
    return request.get(API.balance);
  },
  dataQuestionReview1() {
    return request.get(API.dataQuestionReview1);
  },
  dataQuestionReview2() {
    return request.get(API.dataQuestionReview2);
  },
  dataCodingReview() {
    return request.get(API.dataCodingReview);
  },
  dataQuestionCheck() {
    return request.get(API.dataQuestionCheck);
  },

  dataQuestionSkill() {
    return request.get(API.dataQuestionSkill);
  },
  dataProjectCreate() {
    return request.get(API.dataProjectCreate);
  },
  dataChallengeCreate() {
    return request.get(API.dataChallengeCreate);
  },
  dataHomework() {
    return request.get(API.dataHomework);
  },
  dataChallengeWork() {
    return request.get(API.dataChallengeWork);
  },
  dataTranslateQuestion() {
    return request.get(API.dataTranslateQuestion);
  },
  dataWiki() {
    return request.get(API.dataWiki);
  },
  dataColumn() {
    return request.get(API.dataColumn);
  }
};

export default dataService;
